import { Children, Fragment, ReactNode, isValidElement } from 'react';
import { useParams } from 'react-router-dom';

import { Typography } from '@material-ui/core';

import { Link } from '@backstage/core-components';
import { useRouteRef } from '@backstage/core-plugin-api';

import { Breadcrumbs } from '../../Layout/Breadcrumbs';
import { PageDescriptor, useOptionalPageBridgeProps } from '../utils';

type LooseRouteFunc = (params: Record<string, string | undefined>) => string;

const rendersNothing = (node: ReactNode): boolean => {
  if (node === null || node === undefined || node === false || node === '') {
    return true;
  }
  if (isValidElement(node) && node.type === Fragment) {
    return Children.count(node.props.children) === 0;
  }
  return false;
};

const BreadcrumbLink = ({ ancestor }: { ancestor: PageDescriptor }) => {
  const params = useParams();
  const path = useRouteRef(ancestor.routeRef) as LooseRouteFunc;
  return <Link to={path(params)}>{ancestor.title}</Link>;
};

export const PageBreadcrumbs = () => {
  const bridgeProps = useOptionalPageBridgeProps();

  if (!bridgeProps || bridgeProps.ancestors.length === 0) {
    return null;
  }

  const { ancestors, leafLabel } = bridgeProps;
  const hasLeaf = !rendersNothing(leafLabel);

  return (
    <Breadcrumbs>
      {ancestors.map(ancestor => (
        <BreadcrumbLink key={ancestor.id} ancestor={ancestor} />
      ))}
      {hasLeaf && <Typography noWrap>{leafLabel}</Typography>}
    </Breadcrumbs>
  );
};
